import React, { useEffect, useRef, useState } from 'react';
import WrappingContainer from '../../HOC/WrappingContainer/WrappingContainer';
import WhiteContainer from '../../HOC/WrappingContainer/WhiteContainer';
import * as tableHeader from '../../Moecules/TableHeader/SettingsHeader';
import Tooltip from '../../Atoms/Tooltip/Tooltip';
import { toast } from 'react-toastify';
import blockICon from '../../../assets/Imagess/Campaign/blockIcon.svg';
import unblockICon from '../../../assets/Imagess/Campaign/unblockIcon.svg';
import {
  useBlockUnblockExternalContact,
  useDeleteExternalContactById,
  useFetchExternalContact,
} from '../../../Hooks/Externalcontact';
import { useLocation, useNavigate } from 'react-router-dom';
import SingleTabGroup from '../../Moecules/SingleApplicant/SingleTabGroup';
import TableComponent from '../../Moecules/TableComponent/TableComponent';
import DeletePopup from '../../Moecules/Custom/DeletePopup';
import { useReactToPrint } from 'react-to-print';
import PrintComponent from '../../Moecules/Custom/ExportComponent/PrintComponent';
import ContactButton from './new-contact-atoms/ContactButton';
import { useSearchFilterContext } from '../../../Context/SearchFilterContext';
import TableFilter from '../../Moecules/Custom/TableFilter/TableFilter';
import { visibleColumnData } from './factory/VisbleColumnsData';
import ColumnVisibility from '../../Moecules/TableTopHeader/ColumnVisibility';
import TableTopHeader from '../../Moecules/TableTopHeader/TableTopHeader';

const ExternalContactPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const printRef = useRef();
  const { filterState, updateFilterState, resetFilterState } =
    useSearchFilterContext();
  const {
    searchValue,
    orderByValue,
    orderDirValue,
    page,
    pageSize,
    filteredColumn,
    isFilter,
    filteredByField,
    visibleColumn,
  } = filterState;
  const finalVisibleColumn =
    visibleColumn && Object.keys(visibleColumn).length > 0
      ? visibleColumn
      : visibleColumnData;

  const [isBlock, setIsBlock] = useState(false);
  const [block, setBlock] = useState(false);
  const [deletMode, setDeleteMode] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedContacts, setSelectedContacts] = useState(
    location?.state?.selected || 'All',
  );
  const {
    data: externalContactData,
    refetch: refetchExternalContact,
    isLoading: isExternalContactLoading,
  } = useFetchExternalContact({
    typeId: 21,
    pageSize: pageSize,
    pageNumber: page,
    searchBy: searchValue,
    desc: orderDirValue == 'desc' ? false : true,
    sortBy: orderByValue,
    isBlock: isBlock,
    filterColumns: filteredColumn,
  });
  const { mutate: blockUnblock, isLoading: isBlockingContact } =
    useBlockUnblockExternalContact();
  const {
    mutate: deleteExternalContact,
    isLoading: isDeletingExternalContact,
  } = useDeleteExternalContactById();

  const handleEditClick = (e, item) => {
    e.stopPropagation();
    navigate(`/home/edit-externalContact/${item.externalContactId}`, {
      state: { mode: 'edit', selected: selectedContacts },
    });
  };

  const handleNavigateToContactDetail = (e, id) => {
    e.stopPropagation();
    navigate(`/home/contact-details/${id}`, {
      state: {
        selected: selectedContacts,
      },
    });
  };

  const handleDelete = () => {
    deleteExternalContact(selectedItem?.externalContactId, {
      onSuccess: () => {
        setDeleteMode(false);
        refetchExternalContact();
        toast.success('Deleted successfully');
        setSelectedItem({});
      },
      onError: (error) => {
        console.error('Error deleting email', error);
        toast.error(
          'This option has been used by an applicant and cannot be deleted.',
        );
        setDeleteMode(false);
        setSelectedItem({});
      },
    });
  };

  const handleBlockUnBLock = () => {
    blockUnblock(
      {
        contactId: selectedItem.externalContactId,
        isBlock: !selectedItem.isBlocked,
      },
      {
        onSuccess: () => {
          refetchExternalContact();
          toast.success(
            selectedItem.isBlocked ? 'Unblocked Contact' : 'Blocked Contact',
          );
          setBlock(false);
          setSelectedItem({});
        },
      },
    );
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const handleFilterUpdate = (field, value) => {
    updateFilterState(field, value);
    if (
      field === 'searchValue' ||
      field === 'filteredColumn' ||
      field === 'filteredByField' ||
      field === 'orderByValue' ||
      field === 'orderDirValue'
    ) {
      updateFilterState('page', 1);
    }
  };

  const tableData = {
    data: {
      ...externalContactData?.data,
      items: externalContactData?.data?.items
        ?.filter((item) => item.isBlocked === (selectedContacts !== 'All'))
        .map((item) => ({
          ...item,
          id: item.externalContactId,
        })),
    },
    refetch: refetchExternalContact,
    isLoading: isExternalContactLoading || isBlockingContact,
    tableHeader: tableHeader.externalContactsTableHeader,
  };

  const blockAndUnBlock = (item) => (
    <Tooltip
      content={selectedContacts == 'All' ? 'Deactivate' : 'Activate'}
      red={selectedContacts == 'All'}
    >
      <img
        src={selectedContacts == 'All' ? blockICon : unblockICon}
        onClick={(e) => (
          e.stopPropagation(),
          setBlock(true),
          setSelectedItem(item)
        )}
      />
    </Tooltip>
  );
  const rightButtons = (
    <>
      <TableFilter
        isFilter={isFilter}
        setIsFilter={(value) => handleFilterUpdate('isFilter', value)}
        setFilterByField={(value) =>
          handleFilterUpdate('filteredByField', value)
        }
        setFilteredColumn={(value) =>
          handleFilterUpdate('filteredColumn', value)
        }
      />
      <ColumnVisibility
        tableHeader={tableHeader.externalContactsTableHeader}
        visibleColumn={finalVisibleColumn}
        setVisibleColumn={(value) => updateFilterState('visibleColumn', value)}
      />
    </>
  );
  const additionalButtons = <ContactButton refetch={refetchExternalContact} />;

  const tabContainer = [
    {
      text: 'All Contacts',
      value: 'All',
    },
    {
      text: 'Deactivated Contacts',
      value: 'Blocked Contacts',
    },
  ];

  useEffect(() => {
    if (selectedContacts == 'All') {
      setIsBlock(false);
    } else {
      setIsBlock(true);
    }
  }, [selectedContacts]);

  useEffect(() => {
    refetchExternalContact();
  }, [isBlock]);

  return (
    <WrappingContainer>
      <WhiteContainer white>
        <SingleTabGroup
          tabContainer={tabContainer}
          selected={selectedContacts}
          setSelected={setSelectedContacts}
        />

        {/* <SettingsTopHeader
          title='External Contact'
          search={searchValue}
          setSearch={(value) => handleFilterUpdate('searchValue', value)}
          // handleAddClick={() => navigate('/home/add-externalContact')}
          data={tableData}
          handlePrint={handlePrint}
          // canAdd
          rightButton={rightButtons}
          type={21}
        /> */}
        <TableTopHeader
          isSearch
          search={searchValue}
          setSearch={(value) => handleFilterUpdate('searchValue', value)}
          rightButtons={rightButtons}
          handlePrint={handlePrint}
          additionalButtons={additionalButtons}
          exportData={{
            api: `/api/ExternalContact/GetExternalContacts/${isBlock}`,
            payload: {
              typeId: 21,
              pageSize: externalContactData?.data?.totalCount,
              pageNumber: 1,
              searchBy: searchValue,
              desc: orderDirValue == 'desc' ? false : true,
              ...(orderByValue && { sortBy: orderByValue }),
              isBlock: isBlock,
              filterColumns: filteredColumn,
            },
            visibleColumn: finalVisibleColumn,
            tableHeader: tableHeader.externalContactsTableHeader,
            fileName: 'ExternalContactTemplate',
          }}
        />
        <TableComponent
          tableData={tableData}
          handleEditClick={handleEditClick}
          handleDelete={(e, item) => (
            setDeleteMode(true),
            setSelectedItem(item),
            e.stopPropagation()
          )}
          isOrder
          page={page}
          setPage={(value) => handleFilterUpdate('page', value)}
          pageSize={pageSize}
          setPageSize={(value) => handleFilterUpdate('pageSize', value)}
          setOrderBy={(value) => handleFilterUpdate('orderByValue', value)}
          setOrderDir={(value) => handleFilterUpdate('orderDirValue', value)}
          orderDir={orderDirValue}
          orderBy={orderByValue}
          setFilterByField={(value) =>
            handleFilterUpdate('filteredByField', value)
          }
          editAdd={true}
          additionalIcon={blockAndUnBlock}
          pagination
          handleRowClick={handleNavigateToContactDetail}
          isFilter={isFilter}
          setFilteredColumn={(value) =>
            handleFilterUpdate('filteredColumn', value)
          }
          filteredByField={filteredByField}
          visibleColumn={finalVisibleColumn}
          columnVisibility={true}
          isResize
        />
        {block && (
          <DeletePopup
            handleOnClose={() => setBlock(!block)}
            mode={selectedContacts == 'All' ? 'Deactivate' : 'Activate'}
            handleDelete={handleBlockUnBLock}
            text={
              selectedContacts == 'All'
                ? 'Are you sure you want to deactivate this'
                : 'Are you sure you want to activate this'
            }
            title='user'
            subText={
              selectedContacts == 'All'
                ? 'User will not be included in any campaign.'
                : 'User will be included in any campaign.'
            }
            isLoading={isBlockingContact}
          />
        )}

        {deletMode && (
          <DeletePopup
            handleOnClose={() => (setDeleteMode(false), setSelectedItem({}))}
            title='External Contact'
            handleDelete={handleDelete}
            isLoading={isDeletingExternalContact}
          />
        )}
        <div style={{ display: 'none' }}>
          <PrintComponent
            ref={printRef}
            title='External Contact'
            data={tableData}
          />
        </div>
      </WhiteContainer>
    </WrappingContainer>
  );
};

export default ExternalContactPage;
